import { ButtonAlign } from '../../../types';
import { getButtonBorderColor, getButtonBorderRadius, getButtonBorderStyle, getButtonBorderWidth, } from '../../button-utils';
import { getUpgradedColor } from '../../color/get-upgraded-color';
import { defaultBackgroundColor, defaultLink } from '../../defaults';
import { verifyOrFallbackColor } from '../../verify-or-fallback';
import { extractTextStyles } from '../extract-text-styles';
import { BIG_WIDTH, BIG_WIDTH_PADDING, SMALL_WIDTH, SMALL_WIDTH_PADDING, } from './constants';
import { makePaddingString } from './make-padding-string';
export const extractButton = ({ customStyles, defaultStyles, experiments = {}, isRtl, region, minCalculatedColumnWidth = undefined, defaultButtonAlignment = ButtonAlign.center, }) => {
    const borderStyle = getButtonBorderStyle(defaultStyles);
    const borderWidth = getButtonBorderWidth(customStyles, defaultStyles);
    const borderColor = getButtonBorderColor(customStyles, defaultStyles);
    const borderRadius = getButtonBorderRadius(customStyles, defaultStyles);
    const backgroundColor = verifyOrFallbackColor(defaultBackgroundColor)(getUpgradedColor(customStyles.backgroundColor ||
        defaultStyles.backgroundColor ||
        'transparent'));
    let padding = {
        top: defaultStyles.paddingTop,
        right: defaultStyles.paddingRight,
        bottom: defaultStyles.paddingBottom,
        left: defaultStyles.paddingLeft,
    };
    if (minCalculatedColumnWidth) {
        if (minCalculatedColumnWidth <= SMALL_WIDTH) {
            padding = {
                ...padding,
                right: SMALL_WIDTH_PADDING,
                left: SMALL_WIDTH_PADDING,
            };
        }
        else if (minCalculatedColumnWidth <= BIG_WIDTH) {
            padding = {
                ...padding,
                right: BIG_WIDTH_PADDING,
                left: BIG_WIDTH_PADDING,
            };
        }
    }
    return {
        ...extractTextStyles(customStyles, defaultStyles),
        align: customStyles.align ||
            region.data.buttonAlign ||
            defaultStyles.buttonAlign ||
            defaultButtonAlignment,
        backgroundColor,
        border: `${borderStyle} ${borderWidth} ${borderColor}`,
        borderRadius,
        href: region.data.url || defaultLink,
        innerPadding: makePaddingString({ padding, experiments }),
        text: region.data.label,
        isRtl,
    };
};
//# sourceMappingURL=extract-button.js.map